import THEME from 'pobble-components/dist/theme'

const { COLORS } = THEME

export default {
  container: {
    position: 'relative',
    '& .Select-control': {
      cursor: 'text',
      position: 'relative',
      border: '1px solid #ececec',
      borderRadius: '4px',
      fontSize: '14px',
      lineHeight: '1.2'
    },
    '& .Select-multi-value-wrapper': {
      display: 'flex',
      padding: '5px',
      minHeight: '48px',
      flexWrap: 'wrap'
    },
    '& .Select-menu-outer': {
      position: 'absolute',
      top: '100%',
      width: '100%',
      zIndex: '10000'
    },
    '& .Select-menu': {
      border: '1px solid #DDD',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#fff',
      borderRadius: '4px',
      marginTop: '4px',
      color: COLORS.TEXT.LIGHT_GREY.NORMAL,
      overflow: 'auto',
      maxHeight: '190px'
    },
    '& .Select-input': {
      display: 'flex !important',
      margin: '5px',
      '& input': {
        border: 'none',
        background: 'none'
      }
    },
    '& .Select-noresults': {
      padding: '10px 15px'
    },
    '& .Select-option.is-focused > *': {
      color: COLORS.BLUE.NORMAL
    },
    '& .Select-placeholder': {
      position: 'absolute',
      left: '0',
      top: '0',
      width: '100%',
      padding: '10px',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      color: COLORS.TEXT.LIGHT_GREY.NORMAL
    }
  },
  tag: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
    border: '1px solid #ececec',
    borderRadius: '4px',
    margin: '5px'
  },
  tagClose: {
    color: COLORS.BLUE.NORMAL,
    marginLeft: '2px',
    cursor: 'pointer'
  },
  option: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '10px 15px',
    '&:hover': {
      color: COLORS.BLUE.NORMAL
    }
  },
  oddOption: {
    backgroundColor: '#f9f9f9'
  }
}
